import apiClient from '.';

const userDatabaseUpdateRequest = async (params: any) => {
    try {
        const { data } = await apiClient.get(`admin/update-database`, {
            queryParams: { ...params },
        });
        return data;
    } catch (e: any) {
        return { error: e?.response?.data?.error };
    }
};

export { userDatabaseUpdateRequest };
